import "core-js/modules/es.array.map";

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from 'react';
import classNames from 'classnames';
import { Text } from "./..";
import styles from './List.scss';
var defaultProps = {
  children: null,
  items: null,
  type: null,
  className: ''
};

function List(_ref) {
  var children = _ref.children,
      items = _ref.items,
      type = _ref.type,
      className = _ref.className;

  if (!children && !items) {
    throw new Error('One of props `children` or `items` is required');
  }

  var classes = classNames(styles.list, className, _defineProperty({}, styles[type], type !== null));
  var ListTag = type === 'ordered' ? 'ol' : 'ul'; // has content

  if (children) {
    return /*#__PURE__*/React.createElement(ListTag, {
      role: "list",
      className: classes
    }, children);
  } // has items array


  return /*#__PURE__*/React.createElement(ListTag, {
    role: "list",
    className: classes
  }, items && items.map(function (item, index) {
    return (
      /*#__PURE__*/
      // eslint-disable-next-line react/no-array-index-key
      React.createElement("li", {
        key: "item_".concat(index)
      }, /*#__PURE__*/React.createElement(Text, {
        tag: "span"
      }, item))
    );
  }));
}

List.defaultProps = defaultProps;
export default List;